export default function DonateCancel() {
  return (
    <section className="max-w-3xl mx-auto py-16">
      <h1 className="text-2xl font-bold mb-4">Donation canceled</h1>
      <p>No charge was made. You can try again any time.</p>
    </section>
  );
}
